import { FormikErrors, useField, useFormikContext } from "formik"
import { FormHelperText, Grid } from "@mui/material"
import { ImageUploadField } from "./ImageUploadField"
import { useApiMutation } from "../../../core/api/useApiMutation"
import { uploadImage } from "../../../modules/entities/images/imagesApi"
import { ReactNode } from "react"

type FormikImageUploadProps = Readonly<{
    name: string
    label?: string
    typeOfEntity: string
    bottomContent?: ReactNode
}>

export const FormikImageUpload = ({ name, label, typeOfEntity, bottomContent }: FormikImageUploadProps) => {
    const { setFieldValue, errors } = useFormikContext()
    const [field] = useField(name)
    const { mutateAsync: callUploadImage } = useApiMutation(uploadImage, {
        async onSuccess(_, data) {
            setFieldValue(name, { uid: data.image.uid })
        },
    })

    const handleImageUpload = async (image: File | null) => {
        if (image) {
            await callUploadImage({ image, typeOfEntity })
        } else setFieldValue(name, { uid: image })
    }
    function getNestedError(errors: FormikErrors<any>, path: string): string | undefined {
        return path.split(".").reduce((acc, part) => (acc && acc[part] ? acc[part] : undefined), errors as any)
    }

    const errorMessage = getNestedError(errors, `${name}.uid`)

    return (
        <Grid container gap={1} id={`${name}.uid`}>
            <ImageUploadField
                label={label}
                onImageChange={handleImageUpload}
                previewImage={field.value?.url}
                bottomContent={bottomContent}
            />
            {!!errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
        </Grid>
    )
}
